'use strict';

var util = require('./../../../app_storefront_core_ext/cartridge/js/util'),
    cart = require('./pages/cart'),
    page = require('./../../../app_storefront_core_ext/cartridge/js/page'),
    layout = require('./../../../app_storefront_core_ext/cartridge/js/layout'),
    bonusProductsView = require('./../../../app_storefront_core/cartridge/js/bonus-products-view');

var emitter = window.eventMgr.getEmitter('miniCart');
let flag = false;

var $cache = {},
    selectors = {
        miniCart: '.js-minicart',
        qtyBtn: '.js-qty',
        removeBtn: '.js-item-remove',
        itemQtyField: '.js-item-quantity-field',
        minicartOverlay: '.js-overlay-nav',
        miniCartContent: '.mini-cart-content',
        miniCartToggle: '.mini-cart-toggle',
        miniCartTotal: '.mini-cart-total',
        minicartRedirect: '.js-minicart-redirect'
    },
    cssConstants = {
        hideClass: 'is--hidden',
        showOverlayClass: 'is--mini-cart-show',
        isExpandedClass: 'is--expanded'
    };

function miniCartToggle(showMinicart, $el) {
    if (showMinicart && $cache.$el.find(selectors.minicartRedirect).length) {
        page.redirect(Urls.showCart);
        return;
    }
    // Hide express checkout heading if express checkout is not available in minicart.
    if ($cache.$el.find(selectors.miniCartContent).find('.paypal-cart-buttons-container').length > 0 || $cache.$el.find(selectors.miniCartContent).find('.dw-apple-pay-button').length > 0) {
        $cache.$el.find(selectors.miniCartContent).find('div.mini-cart-payment-heading').removeClass('d-none');
    }

    if($el!= undefined && $el.length > 0 && $(window).width() < 768 ){
        page.redirect(Urls.showCart);
        return;
    }

    $cache.$el.find(selectors.miniCartContent).toggleClass(cssConstants.hideClass, !showMinicart);
    $cache.html.toggleClass(cssConstants.showOverlayClass, showMinicart);
    $cache.minicartOverlay.toggleClass(cssConstants.isExpandedClass, showMinicart);
    $cache.body.toggleClass('mini-cart-show', showMinicart);
    if (!showMinicart) {
        //$cache.document.trigger('minicart.close', false);
    }
    $cache.document.trigger('minicart.show');
    emitter.emit('show');
    $cache.minicartOverlay.removeClass('is--mobile-expanded');
}

function initializeCache() {
    $cache.document = $(document);
    $cache.html = $(document.documentElement);
    $cache.body = $(document.body);
    $cache.$el = $(selectors.miniCart);
    $cache.minicartOverlay = $cache.document.find(selectors.minicartOverlay);
}

function initializeEvents() {
    $(document)
        .on('touchend click', selectors.qtyBtn, function (e) {
            e.stopPropagation();
            e.preventDefault();
            cart.updateQty(this);
            if (pageContext.ns === 'cart') {
                $cache.minicartOverlay.removeClass(cssConstants.isExpandedClass);
            }
        })
        .on('click', selectors.removeBtn, function (e) {
            e.preventDefault();
            var $lineItem = $(this).closest('.js-line-item-row');
            var url = util.appendParamToURL(Urls.removeProductFromMinicart, 'uuid', $lineItem.data('uuid'));
            let removeItem = true;
            let $undoLink = $lineItem.find('.product-undo-link');

            $lineItem.find('.product-undo').addClass('active');
            $undoLink.on('click', function (e) {
                removeItem = false;
                $lineItem.find('.product-undo').removeClass('active');
            });
            setTimeout(function() {
                if(removeItem && pageContext.ns != 'cart') { 
                    var removeAllQty=$lineItem.find('input.js-item-quantity-field').val();
                    if($lineItem.hasClass('c-mini-cart__product-item-row')){
                        removeAllQty = $lineItem.find('.c-mini-cart-qty .value')[0].innerHTML;
                        if (pageContext.ns === 'cart') {
                            $cache.minicartOverlay.removeClass(cssConstants.isExpandedClass);
                            $(document).trigger('minicart.close', true);
                        }
                    }
                    $cache.document.trigger('product.removeFromCart', [$lineItem, removeAllQty]);
                    cart.updateCart(url);
                }
            }, 3000);
        })
        .on('click', selectors.miniCartTotal, () => {
            miniCartToggle(true, $cache.$el);
            $cache.document.trigger('menu.close');
            emitter.emit('toggled');
            let $headerHeight = Math.trunc($('#header').outerHeight());
            $('.c-mini-cart-content').css('top', $headerHeight);
            if($('.js-header.header').hasClass('transparent')){
                flag = true;
                $('.js-header.header').removeClass('transparent');
            }
            else {
                flag = false;
            }
        })
        .on('change', selectors.itemQtyField, function () {
            if($(this).parents('.product-edit-modal').length > 0 || $(this).parents('.js-minicart').length > 0) {
                cart.updateQtyOnInput(this, (parseInt($(this).val(), 10) === 0));
            }
            $cache.html.toggleClass(cssConstants.showOverlayClass, false);
        });

    $cache.document
        .on('click', selectors.miniCartToggle + ', ' + selectors.minicartOverlay, () => miniCartToggle(false))
        .on('minicart.close', () => {
            $cache.$el.find(selectors.miniCartContent).toggleClass(cssConstants.hideClass, true);
            $cache.body.removeClass('mini-cart-show');
            $cache.html.toggleClass(cssConstants.showOverlayClass, false);
            $('.c-mini-cart-content').css('top', '0');
            if(flag === true){
                $('.js-header.header').addClass('transparent');
            }
        });

    if (layout.isMobile() || layout.isTablet()) {
        $(selectors.itemQtyField).prop('disabled', true);
    }

    $(window).on('load', function() {
        setTimeout(function() {
            $('.mini-cart-total').removeClass('inactive');
        }, 1000);
    });
}

var minicart = {
    init: function () {
        initializeCache();
        initializeEvents();
    },

    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {
        this.update(html);
        util.scrollBrowser(0);
        miniCartToggle(true);
        bonusProductsView.loadBonusOption();
    },

    update: function (html) {
        var $update = $(html).filter((index, node) => {
            return node.nodeName === 'DIV';
        }).html();
        $cache.$el.html($update);
    },

    loadBonusProducts: bonusProductsView.loadBonusOption,

    miniCartToggle: miniCartToggle
};

module.exports = minicart;
